import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChartTreemap = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 9.875C2 8.01172 3.51172 6.5 5.375 6.5H12.125C13.9883 6.5 15.5 8.01172 15.5 9.875V14.375C15.5 16.2383 13.9883 17.75 12.125 17.75H5.375C3.51172 17.75 2 16.2383 2 14.375V9.875ZM2 25.625C2 23.7617 3.51172 22.25 5.375 22.25H12.125C13.9883 22.25 15.5 23.7617 15.5 25.625V30.125C15.5 31.9883 13.9883 33.5 12.125 33.5H5.375C3.51172 33.5 2 31.9883 2 30.125V25.625ZM22.8125 6.5H35.1875C36.7414 6.5 38 7.75859 38 9.3125V10.4375C38 11.9914 36.7414 13.25 35.1875 13.25H22.8125C21.2586 13.25 20 11.9914 20 10.4375V9.3125C20 7.75859 21.2586 6.5 22.8125 6.5ZM20 19.4375C20 17.8836 21.2586 16.625 22.8125 16.625H35.1875C36.7414 16.625 38 17.8836 38 19.4375V20.5625C38 22.1164 36.7414 23.375 35.1875 23.375H22.8125C21.2586 23.375 20 22.1164 20 20.5625V19.4375ZM22.8125 26.75H35.1875C36.7414 26.75 38 28.0086 38 29.5625V30.6875C38 32.2414 36.7414 33.5 35.1875 33.5H22.8125C21.2586 33.5 20 32.2414 20 30.6875V29.5625C20 28.0086 21.2586 26.75 22.8125 26.75Z",
		fill: "white"
	})
});
export default SvgChartTreemap;
